import styles from './order-details.module.scss';
import mainOrderStyles from '../orders-page.module.scss';
import cl from 'classnames';
import { HorizontalLine, SectionContainer } from '@touche-lts/panel-ui/dist';
import { observer } from 'mobx-react-lite';
import { IconClose, IconPriceTag2 } from 'assets/icons';
import { useRootStore } from 'mobx-stores/store-provider';
import { capitalize } from 'lodash';
import { Fragment, useEffect, useState } from 'react';
import moment from 'moment';
import { RatingStars } from 'components/common';
import { UserRoleName } from "models";

const OrderSummaryComponent = () => {

    const {
        ordersDetailsStore: {
            setOrderDetails,
            statusOrderDetails,
            rateStoreProduct,
            statusShown,
            statusErroShown
        },
        accountStore: {
            accountDetails,
            getUserById
        },
        userStore: { assignedStore: store }
    } = useRootStore()

        const userDetailsId = JSON.parse(localStorage.getItem('userDetails'))?.id
        const isAdmin = accountDetails?.role?.name === UserRoleName.STORE_ADMIN ||
        accountDetails?.role?.name === UserRoleName.SUPER_ADMIN,

        myRatingLabel = !!store ? 'Customer rating' : 'My rating',
        [brandRatingText, setBrandRatingText] =
            useState(!!statusOrderDetails?.brand?.reviews[0] ? myRatingLabel : 'Rate this store'),
        
        handleProductLabel = (product: any): string => {
            if(!!product?.review)
                return myRatingLabel;
            else
                return 'Rate this product';

        },

        handleRateStore = (rate: number) => {
            const payloadRateProduct = {
                rating: rate,
                review: "              ",
                storeId: store?.id ?? statusOrderDetails.shop,
                userId: store?.id ?? accountDetails.id,
                userName: store?.name ?? accountDetails.emailAddress
            }
            rateStoreProduct(payloadRateProduct);
        },
        handleRateProduct = (rate: number, productId: number) => {
            const payloadRateProduct = {
                productId: productId,
                rating: rate,
                review: "              ",
                userId: store?.id ?? accountDetails.id,
                userName: store?.name ?? accountDetails.emailAddress
            }
            rateStoreProduct(payloadRateProduct);
        }

        useEffect(() => {
            if (userDetailsId && !accountDetails) {
                getUserById(userDetailsId)
            }
        }, [getUserById, userDetailsId, accountDetails])

    return (
        <div className={styles.preContainer}>
            <div className={styles.container}>
                <div className={styles.header}>
                    <button className={styles.closeButton} onClick={() => setOrderDetails(false)}>
                        <IconClose />
                    </button>

                 

                    <h2 className={styles.headerTitle}>
                        Order #{statusOrderDetails.number}
                        <div className={styles.statusOption}>
                            <span className={mainOrderStyles[statusOrderDetails.status]}></span>
                            <p>{statusShown(statusOrderDetails.status)}</p>
                        </div>
                        <div className={styles.statusOption}>
                            <p>{statusErroShown(statusOrderDetails.status,statusOrderDetails.errorStatus)}</p>
                        </div>
                    </h2>
                    <div className={styles.totalPrice}>
                        <p>{moment(statusOrderDetails.date).format('DD MMM YYYY')}</p>
                        <p>({(statusOrderDetails.products.reduce((sum, p) => sum + p.count, 0))}) items</p>
                        <div className={styles.totalSummary}>
                            <span>
                                <IconPriceTag2 /> Total:
                            </span>
                            <span>USD ${statusOrderDetails.total} </span>
                        </div>
                    </div>
                </div>

                <div className={cl(styles.body, styles.scrollable)}>
                    <SectionContainer className={styles.section} colorPreset='dark'>

                        <h3
                            className={cl(styles.sectionHeader)}
                            style={{ justifyContent: 'space-between' }}
                        >
                            <span>
                                {statusOrderDetails.brand.name}
                            </span>
                            <div className={styles.rateThisStore}>
                                <span>{brandRatingText}</span>
                                <span>
                                    <RatingStars
                                        rate={(rate: number) => { handleRateStore(rate) }}
                                        rating={statusOrderDetails?.brand.reviews[0]?.rating}
                                        reviewsCount={statusOrderDetails?.brand.reviewsCnt}
                                        selfRating={true}
                                        isAdmin={isAdmin}
                                        disabled={statusOrderDetails?.status !== 'charged'}
                                        style={{ justifyContent: 'flex-end' }}
                                    />
                                </span>
                            </div>
                        </h3>

                        <HorizontalLine colorPreset='dark' />

                        {statusOrderDetails?.products && statusOrderDetails?.products?.map((orderProduct, index) => {
                            const isLastProduct = index === statusOrderDetails.products.length - 1;

                            return (
                                <Fragment key={index}>
                                    <div className={styles.orderDetailsContainer}>
                                        <img className="rounded" src={orderProduct?.product.images[0].url} alt="Order Details Pic" />
                                        <div className={styles.orderBodyContainer}>
                                            <div className={styles.orderHeading}>
                                                <h4 className={styles.orderProductHeading}>
                                                    {orderProduct?.product.name}
                                                </h4>
                                                <p className={styles.orderPrice}>
                                                    ${orderProduct.price} {/* {formatPrice(price)} */}
                                                    {/* {priceLegend && <span>{priceLegend}</span>} */}
                                                </p>
                                                <div className={styles.skuInfo}>
                                                    <p>Quantity: {orderProduct?.count}</p>
                                                    <p>SKU: {orderProduct?.sku?.sku}</p>
                                                    <p>{handleProductLabel(orderProduct)}</p> {/** TODO-A RATING TEXT TO SEE HOW TO MANAGE */}
                                                    {/** TODO-A Check how to rate products */}
                                                    <p>
                                                        <RatingStars
                                                            rate={(rate: number) => { handleRateProduct(rate, orderProduct?.product.id) }}
                                                            rating={orderProduct?.review?.rating}
                                                            reviewsCount={orderProduct?.product.reviewsCnt}
                                                            selfRating={true}
                                                            isAdmin={isAdmin}
                                                            disabled={statusOrderDetails?.status !== 'charged'}
                                                            style={{ justifyContent: 'flex-end' }}
                                                        />
                                                    </p>
                                                </div>
                                            </div>
                                            <div className={styles.productProps}>
                                                {orderProduct?.attributes.map((attr, indx) => (
                                                    <span key={indx}>
                                                        {capitalize(attr?.group.name)}: {attr?.value.name}
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={styles.shipping} style={{ marginTop: 30 }}>
                                        <p>Shipping</p>
                                        <p>
                                            {capitalize(orderProduct?.shipping?.name)} - <span>{orderProduct?.shipping?.currency} ${orderProduct?.shipping?.price.toFixed(2)}</span>
                                        </p>
                                    </div>
                                    {!isLastProduct && <HorizontalLine />}
                                </Fragment>
                            );
                        })}

                    </SectionContainer>

                    <div className={styles.totalsContainer}>

                        <p className={styles.totalLine}>
                            <span>Items ({statusOrderDetails.products.reduce((sum, p) => sum += p.count, 0)})</span>
                            <span>USD {(statusOrderDetails.products.reduce((sum, p) => sum + (p.count * p.price), 0)).toFixed(2)}</span>
                        </p>

                        <p className={styles.totalLine}>
                            <span>Shipping fee</span>
                            <span>USD ${(statusOrderDetails.products.reduce((sum, p) => sum += p.shipping.price, 0)).toFixed(2)}</span>
                        </p>

                        <div className={styles.horizontalLine} />

                        <p className={styles.totalLine}>
                            <span>Total paid</span>
                            <span>USD ${statusOrderDetails.total.toFixed(2)} </span>
                        </p>
                    </div>

                </div>
            </div>
        </div >
    );
};

const OrderDetails = observer(OrderSummaryComponent)
export { OrderDetails }
